<template>
  <div>
    <div class="content">
        <div class="check-step">
          <ul>
            <li v-for="(group,index) in attrGroups" style="list-style-type:none" :class="{ 'curStep': curStep >= index}">
              {{ index+1 }}.{{ group.groupLabel }}
            </li>
          </ul>
      </div>
    </div>
    <div class="content data-block" style="top: 3.5rem; height: 28.5rem;">
      <div v-if="error" style="text-align: center;color: #FF0000;">{{error}}</div>
      <div class="list-block" :class="{'bottom': curStep === 0 || curStep === 1}">
      <ul>
          <li v-for="(attribute,index) in curAttrsInGroup" class="item-content" :class="getCss(attribute)" v-if="attribute.customizable === 1 && attribute.isNA === false && attribute.value !== -1">
            <editor :is="getEditor(attribute)" v-on:controlForm="controlForm" :attribute="attribute"  :attrGroups = "attrGroups" :index="index"  :curAttrsInGroup="curAttrsInGroup" :customAttrs="merchandise._customizableAttributes"/>
          </li>
        </ul>
      </div>
      <div class="content-block top" v-if='curStep === steps-1' :class="{'bottom': curStep === steps-1}">
        <div class="row">
          <div class="col-100" v-if="this.$route.query.cust">
            <div style="text-align: center;margin-bottom: 0.7rem">请点击加入购物车按钮完成定制</div>
            <a v-on:click="modifyProduct" class="button button-big button-fill button-success">完成修改</a>
          </div>
          <div class="col-100" v-else-if="QuoteStatus === false">
            <div style="text-align: center;margin-bottom: 0.7rem">请点击加入购物车按钮完成定制</div>
            <a v-on:click="calculatePrice" class="button button-big button-fill button-success">加入购物车</a>
          </div>
          <div class="col-100" v-else >
            <div style="text-align: center;margin-bottom: 0.7rem">此报价不可再添加商品</div>
            <a v-on:click="" class="button button-big button-fill button-success gotopay_button_style" style="background-color: gray">加入购物车</a>
          </div>
        </div>
      </div>
    </div>
    <footer class="bar bar-footer-secondary" style="height: 3.5rem;margin: auto;position: fixed">
      <div style="position: relative;bottom: 1.25rem;" class="content-block buttons-row">
        <button @click="pageUp" class="button button button-round">上一步</button>
        <button @click="pageDown" class="button button button-round"  v-if="curStep !== steps-1">下一步</button>
        <button  class="button button button-round" style="color: rgb(142, 142, 147);"  v-else>下一步</button>
      </div>
    </footer>
  </div>
</template>

<script>
//  import $ from 'jquery'
  import AttrEnumBox from './AttrEnumBox2'
  import AttrGeneBox from './AttrGeneBox'
  import AttrGeneInfoBox from './AttrGeneInfoBox'
  import AttrTextBox from './AttrTextBox'
  import AttrTextAreaBox from './AttrTextAreaBox'
  import AttrTextArea2Box from './AttrTextArea2Box'
  import AttrNumberBox from './AttrNumberBox'
  import AttrTVBox from './AttrTVBox'
  import ContractBox from './ContractChoose.vue'
  import TargetBox from './TargetChoose.vue'
  import TemContractBox from './TemContractChoose.vue'

  import Emkt from '../../emkt'
  import $ from 'jquery'
  import {mapState, mapMutations} from 'vuex'
  export default {
    mounted () {
//      this.fetchData()
    },
    computed: {
      steps: function () {
        if (this.merchandise) {
          return this.merchandise._customizableAttrGroupsList.length
        }

        return 0
      },
      ...mapState([
//        'geneSearchResult', 'cartList', 'custdata'
        'geneSearchResult', 'cartList', 'hardGeneInfo'
      ]),
      attrGroups: function () {
        if (this.merchandise === undefined) {
          this.merchandise = Emkt.getLocalStorage('EmktCustomizedMerchandise')
        } else if (this.merchandise) {
          if (typeof this.$route.query.cust === 'object') {
            if (this.$route.query.cust._attributes.PreContract.value !== '-1' && this.$route.query.cust._attributes.TVInfo.value !== '-1') {
              Emkt.setLocalStorage('TLNo', this.$route.query.cust._attributes.TVInfo.value)
            } else {
              Emkt.setLocalStorage('TLNo', null)
            }
            let custAttr = this.$route.query.cust._attributes
            let merAttr = this.merchandise._customizableAttributes
            this.merchandise._customizableAttrGroups = {}
            this.merchandise._customizableAttrGroupsList = []
            let geneObj
            for (var i in merAttr) {
              if (i === 'GeneInfo') {
                let val = custAttr[i].value
                let text
                if (typeof val === 'string' && val.indexOf(',') !== -1) {
                  let obj = JSON.parse(val)
//                  let obj = val
                  geneObj = obj
                  text = geneObj.symbol === undefined ? geneObj.microNo : geneObj.symbol
                } else if (typeof val === 'object') {
                  text = val.symbol === undefined ? val.microNo : val.symbol
                } else if (typeof val === 'string' && val.indexOf(',') === -1) {
                  let obj = val
                  geneObj = obj
                  text = geneObj.symbol === undefined ? geneObj.microNo : geneObj.symbol
                }
                merAttr[i].value = geneObj === undefined ? val : geneObj
                merAttr[i].valueText = text
                merAttr[i].isNA = false
              } else if (i === 'GeneInfo.NMID' && custAttr[i] === undefined) {
                merAttr[i].value = geneObj.NMID
                merAttr[i].valueText = geneObj.NMID
                merAttr[i].isNA = false
              } else if (i === 'GeneInfo.symbol' && custAttr[i] === undefined) {
                merAttr[i].value = geneObj.symbol
                merAttr[i].valueText = geneObj.symbol
                merAttr[i].isNA = false
              } else if (i === 'GeneInfo.CDSSize' && custAttr[i] === undefined) {
                merAttr[i].value = geneObj.CDSSize
                merAttr[i].valueText = geneObj.CDSSize
                merAttr[i].isNA = false
              } else if (i === 'GeneInfo.taxId' && custAttr[i] === undefined) {
                merAttr[i].value = geneObj.taxId
                merAttr[i].valueText = geneObj.taxId
                merAttr[i].isNA = false
              } else if (custAttr[i] && custAttr[i].value && custAttr[i].value !== undefined) {
                if (custAttr[i].value.toString() === '-1') {
                  merAttr[i].value = -1
                  merAttr[i].valueText = -1
                  merAttr[i].isNA = true
                } else {
                  merAttr[i].value = custAttr[i].value
                  merAttr[i].valueText = custAttr[i].valueText
                }
              } else {
                merAttr[i].value = -1
                merAttr[i].valueText = -1
                merAttr[i].isNA = true
              }
              merAttr[i]['sorteditAble'] = true
              // 处理定制属性组
              this.attrGroupHandler(merAttr, i)
            }
            this.merchandise._customizableAttrGroupsList.sort(function (a, b) {
              return a.attrGroupId - b.attrGroupId
            })
          }
          this.iscontrol = false
          return this.merchandise._customizableAttrGroupsList
        }
      },
      curAttrsInGroup () {
        var curGroup = this.attrGroups[this.curStep]
        if (curGroup) {
          if (this.curStep === 2) {
            for (var i = 0; i < curGroup.attrs.length; i++) {
              curGroup.attrs[i].sorteditAble = true
            }
          } else {
            // 设置第一个可以edit
            curGroup.attrs[0].sorteditAble = true
          }
          return curGroup.attrs
        }
        return []
      },
      curGroup () {
        var curGroup = this.attrGroups[this.curStep]
        return curGroup
      },
      curStep: {
        get: function () {
          if (!this.merchandise) {
            return 0
          }
          return this.merchandise._curStep
        },
        // setter
        set: function (newValue) {
          this.merchandise._curStep = newValue
        }
      },
      error () { // 检查当前组是否有错
        return null
      },
      validate () { // 检查当前组是否有错, 是否属性值都填写了
        return null
      }
    },
    components: {
      'attr-enum-box': AttrEnumBox,
      'attr-gene-box': AttrGeneBox,
      'attr-geneInfo-box': AttrGeneInfoBox,
      'attr-text-box': AttrTextBox,
      'attr-number-box': AttrNumberBox,
      'attr-tv-box': AttrTVBox,
      'attr-text-area-box': AttrTextAreaBox,
      'attr-text-area2-box': AttrTextArea2Box,
      'attr-contract-box': ContractBox,
      'attr-target-box': TargetBox,
      'attr-temcontract-box': TemContractBox

    },
    data () {
      return {
        merchandise: Emkt.getLocalStorage('EmktCustomizedMerchandise'),
        EmktMetaData: Emkt.getLocalStorage('EmktMetaData'),
        bMerchandise: {},
        geneObject: {},
        muGuid: '',
        QuoteStatus: Emkt.getLocalStorage('QuoteStatus'),
        ToolNo: ['CV004', 'CV005', 'CV011', 'CV015', 'CV016', 'CV017', 'CV020', 'CV021', 'CV023', 'CV027', 'CV028', 'CV029', 'CV030', 'CV031', 'CV034', 'CV035', 'CV036', 'CV037', 'CV038', 'CV047', 'CV048', 'CV054', 'CV059', 'CV062', 'CV071', 'CV074', 'CV088', 'CV092', 'CV093', 'CV101', 'CV103', 'CV107', 'CV108', 'CV109', 'CV111', 'CV113', 'CV115', 'CV117', 'CV118', 'CV119', 'CV121', 'CV122', 'CV124', 'CV125', 'CV126', 'CV127', 'CV131', 'CV132', 'CV133', 'CV134', 'CV135', 'CV136', 'CV137', 'CV138', 'CV139', 'CV142', 'CV144', 'CV148', 'CV151', 'CV152', 'CV153', 'CV156', 'CV158', 'CV159', 'CV160', 'CV161', 'CV162', 'CV163', 'CV164', 'CV168', 'CV170', 'CV172', 'CV173', 'CV174', 'CV175', 'CV177', 'CV179', 'CV180', 'CV181', 'CV189', 'CV191', 'CV194', 'CV195', 'CV197', 'CV198', 'CV199', 'CV200', 'CV201', 'CV202', 'CV204', 'CV207', 'CV208', 'CV209', 'CV210', 'CV211', 'CV212', 'CV213', 'CV214', 'CV215', 'CV216', 'CV217', 'CV218', 'CV219', 'CV220', 'CV222', 'CV223', 'CV225', 'CV226', 'CV228', 'CV230', 'CV231', 'CV238', 'CV239', 'CV240', 'CV241', 'CV243', 'CV244', 'CV246', 'CV247', 'CV248', 'CV251', 'CV260', 'CV261', 'CV262', 'CV267', 'CV270', 'CV275', 'CV276', 'CV277', 'CV280', 'CV281', 'CV284', 'CV286', 'CV290', 'CV292', 'CV319', 'CV373', 'CV476', 'GV105', 'GV111', 'GV114', 'GV131', 'GV132', 'GV133', 'GV156', 'GV157', 'GV158', 'GV162', 'GV169', 'GV171', 'GV174', 'GV179', 'GV180', 'GV187', 'GV190', 'GV193', 'GV196', 'GV200', 'GV203', 'GV212', 'GV221', 'GV222', 'GV224', 'GV226', 'GV227', 'GV231', 'GV241', 'GV243', 'GV244', 'GV245', 'GV246', 'GV247', 'GV255', 'GV318', 'GV322', 'GV323', 'GV324', 'GV325', 'GV339', 'GV346', 'GV353', 'GV368', 'GV379', 'GV382', 'GV400', 'GV401', 'GV402', 'GV403', 'GV404', 'GV405', 'GV421', 'GV422', 'GV423', 'GV424', 'GV426', 'GV427', 'GV428', 'GV429', 'GV430', 'GV431', 'GV433', 'GV436', 'GV437', 'GV438', 'GV439', 'GV440', 'GV441', 'GV442', 'GV443', 'GV444', 'GV445', 'GV446', 'GV447', 'GV448', 'GV449', 'GV450', 'GV451', 'GV452', 'GV453', 'GV454', 'GV455', 'GV456', 'GV457', 'GV459', 'GV471', 'GV472', 'GV474', 'GV477', 'GV482', 'GV484', 'GV499', 'GV510', 'GV516', 'GV523', 'GV528', 'GV533', 'GV560', 'GV561', 'GV562', 'GV608', 'GV609', 'GV635', 'GV637', 'GV653', 'GV669', 'CV032', 'CV033', 'CV066', 'CV104', 'CV232', 'CV252', 'CV253', 'CV271', 'CV604', 'CV627', 'GV127', 'GV311', 'GV312', 'GV313', 'CV701']
      }
    },
    props: [
    ],
    watch: {
      'curGroup': {
        deep: true,
        handler: function (val, oldVal) {
          console.log(val)
          // 当前步骤有任何属性的改动， 必须清除下一步界面里面的属性值
        }
      },
//      '$route': 'getContract',
      $route () {
        this.getContract()
        if (this.$route.query.cust) {
//          this.clearCust()
          this.initoptions()
        } else {
          this.attrHandler()
        }
      }
    },
    methods: {
      ...mapMutations([
        'ADD_CART_LIST', 'DELETE_CART_LIST', 'REMOVE_FROM_CART_LIST'
      ]),
      getEditor (attribute) {
        if (attribute.customizable === 1) {
          if (attribute.columnName === 'PreContract') {
            return 'attr-contract-box'
          } else if (attribute.columnName === 'CloneNrSelect') {
            return 'attr-target-box'
          } else if (attribute.columnName === 'TemsPreContract') {
            return 'attr-temcontract-box'
          } else if (attribute.columnName === 'CustRemark') {
            return 'attr-text-area2-box'
          } else {
            if (attribute.sdType === Emkt.SDTGene) {
              return 'attr-gene-box'
            } else if (attribute.sdType === Emkt.SDTToolVector) {
              return 'attr-tv-box'
            } else if (attribute.sdType === Emkt.SDTEnumeration) {
              return 'attr-enum-box'
            } else if (attribute.sdType === Emkt.SDTInteger) {
              return 'attr-number-box'
            } else if (attribute.sdType === Emkt.SDTDecimal) {
              return 'attr-number-box'
            } else {
              return 'attr-text-area-box'
            }
          }
        }
      },
      getContract () {
//        if (this.$route.name === 'custOrder') {
//          this.gcapi('searchContractNo').then(function (response) {
//            Emkt.setLocalStorage('contractNO', null)
//            Emkt.setLocalStorage('contractNO', response.body.result)
//          })
//        }
      },
      initoptions () {
        if (this.$route.query.cust) {
          var k = 0
          var j = 0
          var custarray = []
          if (this.merchandise._customizableAttrGroupsList[0].attrs[0].value === '') {
            if (this.$route.query.cust._attributes.PreContract.value !== '-1' && this.$route.query.cust._attributes.TVInfo.value !== '-1') {
              Emkt.setLocalStorage('TLNo', this.$route.query.cust._attributes.TVInfo.value)
            }
            let custAttr = this.$route.query.cust._attributes
            let merAttr = this.merchandise._customizableAttributes
            this.merchandise._customizableAttrGroups = {}
            this.merchandise._customizableAttrGroupsList = []
            let geneObj
            for (var i in merAttr) {
              if (i === 'GeneInfo') {
                let val = custAttr[i].value
                let text
                if (typeof val === 'string' && val.indexOf(',') !== -1) {
                  let obj = JSON.parse(val)
//                  let obj = val
                  geneObj = obj
                  text = geneObj.symbol === undefined ? geneObj.microNo : geneObj.symbol
                } else if (typeof val === 'object') {
                  text = val.symbol === undefined ? val.microNo : val.symbol
                } else if (typeof val === 'string' && val.indexOf(',') === -1) {
                  let obj = val
                  geneObj = obj
                  text = geneObj.symbol === undefined ? geneObj.microNo : geneObj.symbol
                }
                merAttr[i].value = geneObj === undefined ? val : geneObj
                merAttr[i].valueText = text
                merAttr[i].isNA = false
              } else if (i === 'GeneInfo.NMID' && custAttr[i] === undefined) {
                merAttr[i].value = geneObj.NMID
                merAttr[i].valueText = geneObj.NMID
                merAttr[i].isNA = false
              } else if (i === 'GeneInfo.symbol' && custAttr[i] === undefined) {
                merAttr[i].value = geneObj.symbol
                merAttr[i].valueText = geneObj.symbol
                merAttr[i].isNA = false
              } else if (i === 'GeneInfo.CDSSize' && custAttr[i] === undefined) {
                merAttr[i].value = geneObj.CDSSize
                merAttr[i].valueText = geneObj.CDSSize
                merAttr[i].isNA = false
              } else if (i === 'GeneInfo.taxId' && custAttr[i] === undefined) {
                merAttr[i].value = geneObj.taxId
                merAttr[i].valueText = geneObj.taxId
                merAttr[i].isNA = false
              } else if (custAttr[i] && custAttr[i].value && custAttr[i].value !== undefined) {
                if (custAttr[i].value.toString() === '-1') {
                  merAttr[i].value = -1
                  merAttr[i].valueText = -1
                  merAttr[i].isNA = true
                } else {
                  merAttr[i].value = custAttr[i].value
                  merAttr[i].valueText = custAttr[i].valueText
                }
              } else {
                merAttr[i].value = -1
                merAttr[i].valueText = -1
                merAttr[i].isNA = true
              }
              merAttr[i]['sorteditAble'] = true
              // 处理定制属性组
              this.attrGroupHandler(merAttr, i)
            }
            this.merchandise._customizableAttrGroupsList.sort(function (a, b) {
              return a.attrGroupId - b.attrGroupId
            })
          }
          custarray = this.madearray(this.merchandise._customizableAttrGroupsList[0].attrs, this.merchandise._customizableAttrGroupsList[0].attrs.length - 1, custarray)
          custarray = this.madearray(this.merchandise._customizableAttrGroupsList[1].attrs, 0, custarray)
          var newarry = []
          for (k = 0; k < custarray.length - 2; k++) {
            newarry.push(custarray[k])
            this.changeValue(newarry, this.merchandise._customizableAttrGroupsList[0].attrs, k)
            if (k === 0 || k === 1 || k === 2 || k === 3 || k === 4 || k === 5) {
              this.changeValue(newarry, this.merchandise._customizableAttrGroupsList[0].attrs, k)
            } else if (k > 5 && k < 8) {
              this.changeValue(newarry, this.merchandise._customizableAttrGroupsList[0].attrs, k + 4)
            } else {
              this.changeValue(newarry, this.merchandise._customizableAttrGroupsList[0].attrs, k + 3)
            }
          }
          this.changeValue(custarray, this.merchandise._customizableAttrGroupsList[1].attrs, 0)
          for (j = 0; j < 3; j++) {
            for (k = 0; k < this.merchandise._customizableAttrGroupsList[j].attrs.length; k++) {
              if (this.merchandise._customizableAttrGroupsList[j].attrs[k].value === '-1') {
                this.merchandise._customizableAttrGroupsList[j].attrs[k].isNA = true
                this.merchandise._customizableAttrGroupsList[j].attrs[k].value = -1
                this.merchandise._customizableAttrGroupsList[j].attrs[k].valueText = ''
              }
            }
          }
        } else {
//          this.attrHandler()
        }
      },
      modifyProduct () {
        var _this = this
        $.confirm('您确定修改此商品信息吗？',
          function () {
            $.showIndicator()
            setTimeout(function () {
              $.hideIndicator()
            }, 300)
            _this.REMOVE_FROM_CART_LIST(_this.$route.query.cust.merchandiseId)
            _this.calculatePrice()
          },
          function () {
            console.log('cancel')
          })
      },
      controlForm (index, curAttrsInGroup) {
        if (this.curStep !== 2) {
          this.judgeValue(curAttrsInGroup, index, this.curStep)
          for (i = 0; i < curAttrsInGroup.length; i++) {
            if (curAttrsInGroup[i].options && curAttrsInGroup[i].options.length < 1 || (curAttrsInGroup[i].columnName === 'CloneNrSelect' && curAttrsInGroup[i].options[1] === '全新定制')) {
              curAttrsInGroup[i].isNA = true
              curAttrsInGroup[i].value = -1
              curAttrsInGroup[i].sorteditAble = false
              curAttrsInGroup[i].valueText = 'NA'
            }
          }
          if (index === 0 && this.curStep === 0) {
            for (var m = 0; m < curAttrsInGroup.length; m++) {
              if (m !== 0) {
                curAttrsInGroup[m].value = ''
                curAttrsInGroup[m].valueText = ''
                curAttrsInGroup[m].sorteditAble = false
                curAttrsInGroup[m].isNA = false
              }
            }
          }
          var i
          for (i = this.curStep + 1; i <= 2; i++) {
            for (var j = 0; j < this.attrGroups[i].attrs.length; j++) {
              if (i === 1) {
                if (j === 0) {
                  this.attrGroups[i].attrs[j].sorteditAble = true
                } else {
                  this.attrGroups[i].attrs[j].sorteditAble = false
                }
              }
              this.attrGroups[i].attrs[j].value = ''
              this.attrGroups[i].attrs[j].valueText = ''
              this.attrGroups[i].attrs[j].isNA = false
            }
          }
          if (curAttrsInGroup[6] && curAttrsInGroup[6].columnName === 'GeneInfo') {
            for (i = index; i < curAttrsInGroup.length; i++) {
              if (index === 6) {
                if (i === 6) {
                  curAttrsInGroup[i].sorteditAble = true
                  curAttrsInGroup[i + 5].sorteditAble = true
                  curAttrsInGroup[i + 5].value = ''
                  curAttrsInGroup[i + 5].valueText = ''
                  curAttrsInGroup[i + 5].isNA = false
                } else if (i !== 7 && i !== 8 && i !== 9 && i !== 10 && i !== 11) {
                  curAttrsInGroup[i].sorteditAble = false
                  curAttrsInGroup[i].value = ''
                  curAttrsInGroup[i].valueText = ''
                  curAttrsInGroup[i].isNA = false
                }
              } else {
//                for (var q = 0; q < curAttrsInGroup.length; q++) {
//                  if (curAttrsInGroup[q].options && curAttrsInGroup[q].options.length < 1) {
//                    curAttrsInGroup[q].isNA = true
//                    curAttrsInGroup[q].value = -1
//                    curAttrsInGroup[q].valueText = 'NA'
//                  }
//                }
                if (index < curAttrsInGroup.length - 1) {
                  var k = index
                  while (curAttrsInGroup[1 + k].isNA === true && k < curAttrsInGroup.length - 2) {
                    k++
                  }
                }
                for (i = index; i < curAttrsInGroup.length - 1; i++) {
                  if (index === i) {
                    curAttrsInGroup[i].sorteditAble = true
                    curAttrsInGroup[1 + k].sorteditAble = true
//                    curAttrsInGroup[i].value = ''
                    curAttrsInGroup[1 + k].value = ''
                    curAttrsInGroup[1 + k].valueText = ''
                    curAttrsInGroup[1 + k].isNA = false
                  } else {
                    if (i !== k + 1) {
                      curAttrsInGroup[i].sorteditAble = false
                      curAttrsInGroup[i].value = ''
                      curAttrsInGroup[i].valueText = ''
                      curAttrsInGroup[i].isNA = false
                    }
                  }
                }
                if (curAttrsInGroup[index].columnName === 'ContractType' && curAttrsInGroup[index].value === '1') {
                  curAttrsInGroup[2].sorteditAble = true
                  curAttrsInGroup[2].value = ''
                  curAttrsInGroup[2].valueText = ''
                  curAttrsInGroup[2].isNA = false
                } else if (curAttrsInGroup[index].columnName === 'ContractType' && curAttrsInGroup[index].value === '2') {
                  curAttrsInGroup[2].sorteditAble = true
                  curAttrsInGroup[2].value = ''
                  curAttrsInGroup[2].valueText = ''
                  curAttrsInGroup[2].isNA = false
                } else if (curAttrsInGroup[index].columnName === 'ContractType' && curAttrsInGroup[index].value === '3') {
                  curAttrsInGroup[2].sorteditAble = true
                  curAttrsInGroup[2].value = ''
                  curAttrsInGroup[2].valueText = ''
                  curAttrsInGroup[2].isNA = false
                }
                if (curAttrsInGroup[index].columnName === 'RequiredGoods' && (curAttrsInGroup[index].value === '3' || curAttrsInGroup[index].value === '4' || curAttrsInGroup[index].value === '5')) {
                  curAttrsInGroup[4].sorteditAble = true
                  curAttrsInGroup[4].value = ''
                  curAttrsInGroup[4].valueText = ''
                  curAttrsInGroup[4].isNA = false
                }
              }
            }
          }
          this.judgeValue(curAttrsInGroup, index, this.curStep)
          for (i = 0; i < curAttrsInGroup.length; i++) {
            if (curAttrsInGroup[i].options && curAttrsInGroup[i].options.length < 1) {
              curAttrsInGroup[i].isNA = true
              curAttrsInGroup[i].sorteditAble = false
              curAttrsInGroup[i].value = -1
              curAttrsInGroup[i].valueText = ''
            }
          }
        }
//        else if (this.curStep === 1) {
//          this.judgeValue(curAttrsInGroup, index, this.curStep)
//        }
      },
      arr (arr) {
        var result = []
        for (var i = 0; i < arr.length; i++) {
          if (result.indexOf(arr[i]) === -1) {
            result.push(arr[i])
          }
        }
        return result
      },
      changeValue (custarray, group, index) {
        console.log('changeValue start----', new Date().getTime())
        if (custarray.length >= 7 && index === custarray.length - 1) {
          if (custarray.length >= 9) {
            index = index + 4
          } else {
            index = index + 3
          }
        }
        var i
        var dictionariesMap = this.EmktMetaData.dictionariesMap
        var datas = []
        datas = Emkt.getLocalStorage('custdata')
        for (i = 0; i < custarray.length; i++) {
          var temarr = []
          for (var j = 0; j < datas.length; j++) {
            if (datas[j][custarray[i].columnName]) {
              for (var n = 0; n < datas[j][custarray[i].columnName].length; n++) {
                if (custarray[i]['value']) {
                  if (custarray[i].columnName === 'TVInfo') {
                    if (datas[j][custarray[i].columnName][n].value.toString().indexOf(custarray[i]['value'].toString()) !== -1) {
                      temarr.push(datas[j])
                    }
                  } else {
                    if (datas[j][custarray[i].columnName][n].value.toString() === custarray[i]['value'].toString()) {
                      temarr.push(datas[j])
                    }
                  }
                }
              }
            }
          }
          if (temarr.length > 0) {
            datas = temarr
          }
        }
        let karry = []
        let mapKarry ={}
        for (i = 0; i < datas.length; i++) {
          var k
          for (k = index + 1; k < group.length; k++) {
            if (datas[i]['GeneInfo.category'][0].value === -1) {
              if (group[k].columnName === 'GeneInfo' || group[k].columnName === 'GeneInfo.CDSSize' || group[k].columnName === 'GeneInfo.symbol' || group[k].columnName === 'GeneInfo.NMID' || group[k].columnName === 'GeneInfo.taxId') {
                group[k].isNA = true
                group[k].value = -1
                group[k].valueText = 'NA'
              }
            } else if (datas[i]['GeneInfo.category'][0].value === '') {
              if (group[k].columnName === 'GeneInfo' || group[k].columnName === 'GeneInfo.CDSSize' || group[k].columnName === 'GeneInfo.symbol' || group[k].columnName === 'GeneInfo.NMID' || group[k].columnName === 'GeneInfo.taxId') {
                group[k].isNA = false
                group[k].value = ''
                group[k].valueText = ''
              }
            }
            if (datas[i][group[k].columnName]) {
              var m
              for (m = 0; m < datas[i][group[k].columnName].length; m++) {
                if (datas[i][group[k].columnName][m].value === -1) {
                  group[k].options = []
                } else {
                  var kvalue2 = {}
                  kvalue2['key'] = group[k].columnName
                  var da = {}
                  let sysData = dictionariesMap[datas[i][group[k].columnName][m].typeID + '_' + datas[i][group[k].columnName][m].value]
                  da.key = datas[i][group[k].columnName][m].value
                  da.value = sysData.dictValue
                  if(sysData.valid) {
                    kvalue2['value'] = da
                    if(mapKarry[da.key]) {
                      let arrayKarry = mapKarry[da.key]
                       if(!arrayKarry.includes(da.value)) {
                         arrayKarry.push(da.value)
                         karry.push(kvalue2)
                       }
                    } else {
                      mapKarry[da.key] = [da.value]
                      karry.push(kvalue2)
                    }
                  }
                  group[k].options = []
                }
              }
            }
          }
        }
        if (group.length !== 6) {
          for (i = 0; i < datas.length; i++) {
            if (datas[i][this.attrGroups[1].attrs[0].columnName]) {
              for (m = 0; m < datas[i][this.attrGroups[1].attrs[0].columnName].length; m++) {
                if (datas[i][this.attrGroups[1].attrs[0].columnName][m].value === -1) {
                  this.attrGroups[1].attrs[0].options = []
                } else {
                  kvalue2 = {}
                  kvalue2['key'] = this.attrGroups[1].attrs[0].columnName
                  kvalue2['value'] = datas[i][this.attrGroups[1].attrs[0].columnName][m].value
                  this.attrGroups[1].attrs[0].options = []
                  // karry.push(kvalue2)
                  if(mapKarry[kvalue2.key]) {
                    let arrayKarry = mapKarry[kvalue2.key]
                    if(!arrayKarry.includes(kvalue2.value)) {
                      arrayKarry.push(kvalue2.value)
                      karry.push(kvalue2)
                    }
                  } else {
                    mapKarry[kvalue2.key] = [kvalue2.value]
                    karry.push(kvalue2)
                  }
                }
              }
            }
          }
          if(mapKarry[this.attrGroups[1].attrs[0].columnName]) {
            this.attrGroups[1].attrs[0].options = mapKarry[this.attrGroups[1].attrs[0].columnName]
          }
          // for (i = 0; i < karry.length; i++) {
          //   if (this.attrGroups[1].attrs[0].columnName === karry[i].key && karry[i]['value'] !== '-1') {
          //     this.attrGroups[1].attrs[0].options.push(karry[i]['value'])
          //   }
          //   if (this.attrGroups[1].attrs[0].options) {
          //     this.attrGroups[1].attrs[0].options = this.arr(this.attrGroups[1].attrs[0].options)
          //   }
          // }
        }
        for (j = 0; j < this.attrGroups[2].attrs.length; j++) {
          this.attrGroups[2].attrs[j].isNA = true
        }

        for (i = 0; i < datas.length; i++) {
          if (datas[i]['otherAttrs']) {
            for (k = 0; k < datas[i]['otherAttrs'].length; k++) {
              for (j = 0; j < this.attrGroups[2].attrs.length; j++) {
                if (datas[i]['otherAttrs'][k] === this.attrGroups[2].attrs[j].columnName.toString()) {
//                  if (datas[i]['TargetNum'].length === 1 && datas[i]['TargetNum'][0] === 1) {
//                    if (this.attrGroups[2].attrs[j].columnName === 'TargetNum') {
//                      this.attrGroups[2].attrs[j].value = 1
//                      this.attrGroups[2].attrs[j].valueText = 1
//                    }
//                  }
                  if (this.attrGroups[2].attrs[j].columnName.toString() === 'LVAmount') {
                    this.attrGroups[2].attrs[j].options = []
                    for (m = 0; m < datas[i]['otherAttrsOptions'].length; m++) {
                      this.attrGroups[2].attrs[j].options[datas[i]['otherAttrsOptions'][m].value] = dictionariesMap[datas[i]['otherAttrsOptions'][m].typeID + '_' + datas[i]['otherAttrsOptions'][m].value].dictValue
                    }
                  }
                  if (this.attrGroups[2].attrs[j].columnName.toString() === 'NC_LV_Amount' || this.attrGroups[2].attrs[j].columnName.toString() === 'NC_Plasmid_Amount') {
                    this.attrGroups[2].attrs[j].options = []
                    for (m = 0; m < datas[i]['otherAttrsNCOptions'].length; m++) {
                      this.attrGroups[2].attrs[j].options[datas[i]['otherAttrsNCOptions'][m].value] = dictionariesMap[datas[i]['otherAttrsNCOptions'][m].typeID + '_' + datas[i]['otherAttrsNCOptions'][m].value].dictValue
                    }
                  }
                  if (this.attrGroups[2].attrs[j].columnName.toString() === 'AAVBloodType') {
                    this.attrGroups[2].attrs[j].options = []
                    for (m = 0; m < datas[i]['AAVBloodTypeOptions'].length; m++) {
                      this.attrGroups[2].attrs[j].options[datas[i]['AAVBloodTypeOptions'][m].value] = dictionariesMap[datas[i]['AAVBloodTypeOptions'][m].typeID + '_' + datas[i]['AAVBloodTypeOptions'][m].value].dictValue
                    }
                  }
                  if (this.attrGroups[2].attrs[j].columnName.toString() === 'Plasmid_Amount') {
                    if (datas[i]['otherAttrsOptions'] && datas[i]['otherAttrsOptions'].length >= 1) {
                      this.attrGroups[2].attrs[j].options = []
                      for (m = 0; m < datas[i]['otherAttrsOptions'].length; m++) {
                        this.attrGroups[2].attrs[j].options[datas[i]['otherAttrsOptions'][m].value] = dictionariesMap[datas[i]['otherAttrsOptions'][m].typeID + '_' + datas[i]['otherAttrsOptions'][m].value].dictValue
                      }
                    }
                  }
                  this.attrGroups[2].attrs[j].isNA = false
                }
              }
            }
          }
        }
//        console.log(this.attrGroups[2].attrs)
        for (i = 0; i < karry.length; i++) {
          for (k = index + 1; k < group.length; k++) {
            if (group[k].columnName === karry[i].key) {
              group[k].options[karry[i]['value'].key] = karry[i]['value'].value
            }
          }
        }
        if(datas[0].MuGuid) {
          this.muGuid = datas[0].MuGuid
        }
//        console.log(this.attrGroups[1].attrs)
        console.log('changeValue end----', new Date().getTime())
        return group
      },
      madearray (curAttrsInGroup, index, custarray) {
        console.log('madearray start----', new Date().getTime())
        var i
        for (i = 0; i < index + 1; i++) {
          if (curAttrsInGroup[i].value !== '') {
            if (curAttrsInGroup[i].columnName !== 'GeneInfo.NMID' && curAttrsInGroup[i].columnName !== 'GeneInfo.CDSSize' && curAttrsInGroup[i].columnName !== 'GeneInfo.symbol' && curAttrsInGroup[i].columnName !== 'GeneInfo.taxId') {
              var data = {}
              if (curAttrsInGroup[i].columnName === 'GeneInfo') {
                if (curAttrsInGroup[i].value === -1 || !curAttrsInGroup[i].value) {
                  data['columnName'] = 'GeneInfo.category'
                  data['value'] = -1
                  custarray.push(data)
                  var data2 = {}
                  data2['columnName'] = 'GeneInfo.ttttflag'
                  data2['value'] = -1
                  custarray.push(data2)
                } else if (curAttrsInGroup[i].value) {
                  data['columnName'] = 'GeneInfo.category'
                  data['value'] = curAttrsInGroup[i].value.category
                  custarray.push(data)
                  var data1 = {}
                  data1['columnName'] = 'GeneInfo.ttttflag'
                  if (curAttrsInGroup[i].value.ttttflag !== undefined) {
                    data1['value'] = curAttrsInGroup[i].value.ttttflag
                    custarray.push(data1)
                  } else {
                    data1['value'] = -1
                    custarray.push(data1)
                  }
                }
              } else if (curAttrsInGroup[i].columnName === 'TemsPreContract') {
                if (curAttrsInGroup[i].value !== -1 && curAttrsInGroup[i].value) {
                  data['columnName'] = curAttrsInGroup[i].columnName
                  data['value'] = 1
                  custarray.push(data)
                }
              } else {
                data['columnName'] = curAttrsInGroup[i].columnName
                data['value'] = curAttrsInGroup[i].value
                custarray.push(data)
              }
            }
          }
        }
        console.log('madearray end----', new Date().getTime())
        return custarray
      },
      judgeValue (curAttrsInGroup, index, curStep) {
//        $('.multiselect__input').attr('disabled', true)
        console.log('judgeValue start----', new Date().getTime())
        var custarray = []
        console.log(this.merchandise)
        if (curStep === 0) {
          custarray = this.madearray(this.attrGroups[0].attrs, index, custarray)
        } else if (curStep === 1) {
          custarray = this.madearray(this.attrGroups[0].attrs, this.attrGroups[0].attrs.length - 1, custarray)
          custarray = this.madearray(this.attrGroups[1].attrs, index, custarray)
        }
        curAttrsInGroup = this.changeValue(custarray, curAttrsInGroup, index)
        console.log('judgeValue end----', new Date().getTime())
      },
      getCss (attribute) {
        return {
          // 'item-link': attribute.sdType === Emkt.SDTGene | attribute.sdType === Emkt.SDTToolVector
        }
      },
      judgeError (val) {
        this.isError = val
      },
      receiveData (data) {
      },
      pageUp () {
        if (this.curStep <= 0) {
          return
        }

        if (this.error) {
          $.toast(this.error)
          return
        }

        this.curStep--
      },
      pageDown () {
        var isachieve = true
        var _this = this
        if (_this.attrGroups[0].attrs[3].value === '2' && _this.curStep === 0) {
          $.modal({
            title: '请核对',
            afterText: '<div>您确定客户提供的腺病毒类型为Ad5亚型，且能在HEK293细胞中扩增。腺病毒毒种滴度>10^7 PFU/mL，毒种体积>50µL?</div>',
            buttons: [
              {
                text: '不确定',
                bold: true,
                onClick: function () {
                  isachieve === false
                  $.alert('请您先与客户确认以上信息！')
                  return
                }
              },
              {
                text: '确定',
                bold: true,
                onClick: function () {
                  if (isachieve === true) {
                    if (_this.curStep >= _this.steps - 1) {
                      return
                    }
                    if (_this.error) {
                      $.toast(_this.error)
                      return
                    }
                    _this.curStep++
                  }
                }
              }
            ]
          })
//          $.confirm('您确定客户提供的腺病毒类型为Ad5亚型，且能在HEK293细胞中扩增。腺病毒毒种滴度>10^7 PFU/mL，毒种体积>50µL?',
//            function () {
//              if (isachieve === true) {
//                if (_this.curStep >= _this.steps - 1) {
//                  return
//                }
//                if (_this.error) {
//                  $.toast(_this.error)
//                  return
//                }
//                _this.curStep++
//              }
//            },
//            function () {
//              isachieve === false
//              $.alert('请您先与客户确认以上信息！')
//              return
//            })
        }
        if (_this.curStep === 1) {
          if (_this.attrGroups[_this.curStep].attrs[0].options.length < 1) {
            _this.attrGroups[_this.curStep].attrs[0].value = '-1'
            _this.attrGroups[_this.curStep].attrs[0].valueText = '-1'
          }
          if (_this.attrGroups[_this.curStep].attrs[0].value === '') {
            isachieve = false
            $.alert('请您将信息填写完整！')
          }
          if (_this.attrGroups[0].attrs[4].value !== '-1' && _this.attrGroups[0].attrs[4].value !== -1 && _this.attrGroups[0].attrs[2].value !== '2') {
            _this.$weui.loading('正在查询中...')
            _this.gcapi('searchPreContract', _this.attrGroups[0].attrs[4].value.split(':')[0]).then(function (response) {
              _this.$weui.loading().hide()
              let data = response.body.result.TLNo
              if (_this.attrGroups[1].attrs[0].value !== data) {
                _this.attrGroups[1].attrs[0].value = data
              }
            }).catch(err=>{
              _this.$weui.loading().hide()
              console.log(err)
            })
          }
          if (Emkt.getLocalStorage('isnext') !== undefined && Emkt.getLocalStorage('isnext') === false) {
            isachieve = false
//            Emkt.setLocalStorage('isnext', true)
            $.alert('请您重新选择基因或载体！')
            return
          }
        }
        if (_this.curStep !== 1) {
          if (_this.attrGroups[0].attrs[12].value === '1') {
                // 慢病毒>6000 || 腺病毒>6500 || 逆转录>4000 ||悬浮病毒6000 || 质粒>10000
            if ((_this.attrGroups[0].attrs[2].value === Emkt.TOOLTYPE_LENTIVIRUS && _this.attrGroups[0].attrs[6].value.CDSSize > 6000) ||
                    (_this.attrGroups[0].attrs[2].value === Emkt.TOOLTYPE_PLASMID && _this.attrGroups[0].attrs[6].value.CDSSize > 10000) ||
                    (_this.attrGroups[0].attrs[2].value === Emkt.TOOLTYPE_ADENOVIRUS && _this.attrGroups[0].attrs[6].value.CDSSize > 6500) ||
                    (_this.attrGroups[0].attrs[2].value === Emkt.TOOLTYPE_RETROVIRUS && _this.attrGroups[0].attrs[6].value.CDSSize > 4000) ||
                    (_this.attrGroups[0].attrs[2].value === Emkt.TOOLTYPE_FLOATVIRUS && _this.attrGroups[0].attrs[6].value.CDSSize > 6000)
                ) {
              isachieve = false
              _this.$weui.alert('您所选择的基因，超出该合同类型的构建或包装极限，公司无法接入，请咨询售前如何实现客户需求，无法加入购物车，重新选择基因')
            }
          }
          if (_this.hardGeneInfo && _this.hardGeneInfo.length > 0) {
            let hardHeneGo = true
            let hardGenecontent = {}
            for (let hardGene of _this.hardGeneInfo) {
              if(hardGene.level === Emkt.HardGeneLevelNo1) {
                if(hardGene.contractType !== undefined && hardGene.contractType) {
                  //有hardGene
                  if (_this.attrGroups[0].attrs[12].value && hardGene.tech.includes(_this.attrGroups[0].attrs[12].value )) {
                    if (hardGene.targetSupplier !== undefined && hardGene.targetSupplier) {
                      if (_this.attrGroups[0].attrs[13].value  && hardGene.targetSupplier.includes(_this.attrGroups[0].attrs[13].value)) {
                        hardHeneGo = false
                        hardGenecontent = hardGene
                        break
                      }
                    } else {
                      hardHeneGo = false
                      hardGenecontent = hardGene
                      break
                    }
                  }
                }
              }
            }
            if(!hardHeneGo) {
              _this.$weui.alert(hardGenecontent.infeasibilityStatement + '，'+ hardGenecontent.solution)
              isachieve = false
            }
          }
          if ((_this.attrGroups[0].attrs[6].value.category === 3) && (_this.attrGroups[0].attrs[6].value.ttttflag !== undefined && _this.attrGroups[0].attrs[6].value.ttttflag === 1)) {
            isachieve = false
            $.alert('microRNA序列中存在连续4个T，需要更换海绵体方法进行构建，不可以继续进行下一步选择，详细邮件询问售前技术支持。')
          }
          for (var j = 0; j < _this.curAttrsInGroup.length; j++) {
            if (_this.curAttrsInGroup[j].value === '') {
              isachieve = false
              $.alert('请您将信息填写完整！')
              break
            }
          }
        }
        if (isachieve === true && (_this.attrGroups[0].attrs[3].value !== '2' || _this.curStep !== 0)) {
          if (_this.curStep >= _this.steps - 1) {
            return
          }
          if (_this.error) {
            $.toast(_this.error)
            return
          }
          _this.curStep++
        }
      },
      fetchData () {
        var self = this
        self.initoptions()
//        this.gcapi('getAllCustomizedMerchandise').then(function (response) {
//          var merch = response.body.result[0]
//          merch._curStep = 0
//          self.merchandise = merch
//          self.initoptions()
//          Emkt.setStoreItem('EmktCustomizedMerchandise', self.merchandise)
//        })
      },
      addCartList (bMerchandise) {
        let id = bMerchandise.merchandiseId
        id = id + new Date().getTime()
        bMerchandise.merchandiseId = id
        bMerchandise.attributes['GeneInfo'] = this.geneObject
        this.ADD_CART_LIST(bMerchandise)
      },
      calculatePrice () {
        // 阴性载体
        if (this.attrGroups[1].attrs[0].value === 'GV127' || this.attrGroups[1].attrs[0].value === 'GV311' ||
            this.attrGroups[1].attrs[0].value === 'CV032' || this.attrGroups[1].attrs[0].value === 'CV253' ||
            this.attrGroups[1].attrs[0].value === 'CV033' || this.attrGroups[1].attrs[0].value === 'CV271' ||
            this.attrGroups[1].attrs[0].value === 'CV604' || this.attrGroups[1].attrs[0].value === 'CV232' ||
            this.attrGroups[1].attrs[0].value === 'CV627' || this.attrGroups[1].attrs[0].value === 'CV627' ||
            this.attrGroups[1].attrs[0].value === 'CV252' || this.attrGroups[1].attrs[0].value === 'CV104' ||
            this.attrGroups[1].attrs[0].value === 'GV312' || this.attrGroups[1].attrs[0].value === 'GV313' ||
            this.attrGroups[1].attrs[0].value === 'CV207' || this.attrGroups[1].attrs[0].value === 'CV275') {
          if (this.attrGroups[2].attrs[23].value === '1') {
            if (this.attrGroups[2].attrs[24].value === '') {
              $.toast('【吉凯载体改造】必须填写【备注信息】！')
              return
            }
          }
        }
        // 慢病毒扩增(Cas9单载体，sgRNA) 不能选择对照
        if (this.attrGroups[0].attrs[0].value === '3' && this.attrGroups[0].attrs[2].value === '1' &&
            this.attrGroups[1].attrs[5].value.toString().indexOf('cas') !== -1 && this.attrGroups[1].attrs[5].value.indexOf('sgRNA') !== -1) {
          if (this.attrGroups[2].attrs[6].value !== '' && this.attrGroups[2].attrs[6].value !== -1) {
            if (this.attrGroups[2].attrs[6].value !== '6') {
              $.toast('此载体【无对照】,如需对照,请咨询售前！')
              return
            }
          }
        }
        if (this.ToolNo.indexOf(this.attrGroups[1].attrs[0].value) !== -1) {
          if (this.attrGroups[2].attrs[12].value !== '' && this.attrGroups[2].attrs[12].value !== -1) {
            if (this.attrGroups[2].attrs[12].value !== '9') {
              $.toast('此载体【无对照】,如需对照,请咨询售前！')
              return
            }
          }
          if (this.attrGroups[2].attrs[6].value !== '' && this.attrGroups[2].attrs[6].value !== -1) {
            if (this.attrGroups[2].attrs[6].value !== '6') {
              $.toast('此载体【无对照】,如需对照,请咨询售前！')
              return
            }
          }
          if (this.attrGroups[2].attrs[16].value !== '' && this.attrGroups[2].attrs[16].value !== -1) {
            if (this.attrGroups[2].attrs[16].value !== '0') {
              $.toast('此载体【无对照】,如需对照,请咨询售前！')
              return
            }
          }
        }
        for (var a in this.curAttrsInGroup) {
          if (this.curAttrsInGroup[a].columnName !== 'TvNoName' && this.curAttrsInGroup[a].columnName !== 'TvNoNumber') {
            if (this.curAttrsInGroup[a].isNA === false && this.curAttrsInGroup[a].value === '') {
              $.alert('请将信息填写完整！')
              return
            }
          }
        }
        Emkt.setLocalStorage('TLNo', null)
        let bMerchandise = this.merchandiseHandler()
        let _this = this
        _this.$weui.loading('正在处理...')
        this.gcapi('productDetect', bMerchandise).then(res => {
          let body = res.body
          _this.$weui.loading().hide()
          if (body.code === 0) {
            let merchandise = {}
            merchandise = body.result.merchandiseDetailForClient
            merchandise.productName = body.result.productName
            merchandise.workdays = body.result.workdays
            merchandise.expressPrice = body.result.expressPrice
            if (body.result.templateSource) {
              merchandise.templateSource = body.result.templateSource
            }
            if (_this.$route.query.cust && _this.$route.query.cust.id) {
              merchandise.id = _this.$route.query.cust.id
            }
            merchandise.newMerch = 1
           if(body.result.hardGeneDescription) {
             _this.$weui.confirm(body.result.hardGeneDescription, function () {
               merchandise.hardGeneDescription = body.result.hardGeneDescription
               _this.addCartList(merchandise)
               _this.attrHandler()
               _this.$router.push({name: 'cart'})
             }, function () {
             })
           }  else {
             _this.addCartList(merchandise)
             _this.attrHandler()
             _this.$router.push({name: 'cart'})
           }
          } else {
            _this.$weui.toast(body.result, 1500)
          }
        })
      },
      merchandiseHandler () {
        let md = this.merchandise
        let bMerchandise = {}
        let attribute = []
        let attr = md._customizableAttributes
        let categoryId
        for (var akey in attr) {
          if (akey === 'GeneInfo') {
            attribute.push({key: akey, value: attr[akey].value.geneGUID})
            categoryId = attr[akey].value.category
            this.geneObject = attr[akey].value
          } else if (akey === 'AAVBloodType]') {
            attribute.push({key: akey, value: attr[akey].value.geneGUID})
            categoryId = attr[akey].value.category
            this.geneObject = attr[akey].value
          } else if(akey === 'MuGuid'){
            attribute.push({
              key: akey,
              value: this.muGuid
            })
          } else {
            let obj = {}
            obj['key'] = akey
            let val = attr[akey].value
            if (val) {
              if (val.value !== undefined) {
                obj['value'] = val.value
              } else {
                obj['value'] = val
              }
            }
            attribute.push(obj)
          }
        }
        console.log(this.attrGroups)
        let cate = {}
        cate['key'] = 'GeneInfo.category'
        cate['value'] = categoryId
        attribute.push(cate)
        bMerchandise.unitPrice = md.priceMax
        bMerchandise.initPrice = bMerchandise.unitPrice
        bMerchandise.merchandiseGuid = md.merchandiseId
        bMerchandise.attributes = attribute
        bMerchandise.newMerch = 1
//        bMerchandise.geneObject = geneObject
        return bMerchandise
      },
      clearCust () {
        let attrs = this.merchandise._customizableAttrGroupsList
        for (var i in attrs) {
          for (var j in attrs[i].attrs) {
            attrs[i].attrs[j].value = ''
            attrs[i].attrs[j].valueText = ''
            attrs[i].attrs[j].sorteditAble = false
            attrs[i].attrs[j].isNA = false
          }
        }
        this.curStep = 0
//        console.log(this.merchandise._customizableAttributes)
      },
      attrHandler () {
        let merAttr = this.merchandise._customizableAttributes
        this.merchandise._customizableAttrGroups = {}
        this.merchandise._customizableAttrGroupsList = []
        for (var i in merAttr) {
          merAttr[i].value = ''
          merAttr[i].valueText = ''
          merAttr[i]['sorteditAble'] = false
          merAttr[i]['isNA'] = false
          // 处理定制属性组
          this.attrGroupHandler(merAttr, i)
        }
        this.merchandise._customizableAttrGroupsList.sort(function (a, b) {
          return a.attrGroupId - b.attrGroupId
        })
        this.curStep = 0
      },
      attrGroupHandler (merAttr, i) {
        var attrGroupId = merAttr[i].groupId
        let g = this.merchandise._customizableAttrGroups[attrGroupId]
        if (!g) {
          g = Emkt.getEmktMetaData().categoryAttrGroupsMap[merAttr[i].groupId]
          g.attrNames = []
          g.attrs = []
          this.merchandise._customizableAttrGroups[attrGroupId] = g
          this.merchandise._customizableAttrGroupsList.push(g)
        }
        g.attrNames.push(i)
        g.attrs.push(merAttr[i])
      }
    }
  }
</script>

<style type="text/css" scoped>
  .check-step {
    /*padding: 5px 0;*/
  }
  .check-step ul {
    display: -ms-flexbox;
    display: flex;
    margin: 0.5rem 0 0.5rem 0; }
  .check-step ul:after {
    visibility: hidden;
    display: block;
    content: " ";
    clear: both; }
  .check-step li {
    position: relative;
    float: left;
    -ms-flex: 1;
    flex: 1;
    width: 33%;
    line-height: 1.5em;
    padding: 0 1em 1em 1em;
    border-bottom: 2px solid #ccc;
    color: #999;
    font-size: 16px;
    text-align: center; }
  .check-step li:after {
    position: absolute;
    bottom: -7px;
    left: 50%;
    margin-left: -7px;
    content: "";
    width: 14px;
    height: 14px;
    border-radius: 50%;
    background: #ccc; }
  .check-step li.curStep {
    border-color: #0894EC;
    color: #0894EC;
    list-style-type:none}
  .check-step li.curStep:after {
    background: #0894EC; }

  @media only screen and (max-width: 767px) {
    .check-step ul {
      margin-left: -20px;
      margin-right: 20px; }
    .check-step li {
      font-size: 12px; } }

  .checkout-title {
    position: relative;
    margin-bottom: 10px;
    margin-top: 10px;
    text-align: center; }
  .checkout-title span {
    position: relative;
    padding: 0 1em;
    background-color: #EFEFF4;
    font-family: "moderat", sans-serif;
    font-weight: bold;
    font-size: 16px;
    color: #605F5F;
    z-index: 1; }
  .checkout-title:before {
    position: absolute;
    top: 50%;
    left: 0;
     tent: "";
    width: 100%;
    height: 1px;
    background: #ccc;
    z-index: 0; }
  .item-input {
    width: 9rem;
  }
  .list-block {
    margin-top: 0;
    margin-bottom: 0;
    top: 7rem;
  }
  .data-block {
    height: 21.4rem;
    position: absolute;
    top: 6.5rem;
    bottom: 11rem;
  }
  .bottom{
    margin-bottom: 7.2rem;
  }
  .top{
    margin-top: 0.5rem;
  }

</style>



// WEBPACK FOOTER //
// CustOrder.vue?f72e0cbc